import {useBatchMultiple} from "../@hooks";
import { AppSelectionBar, AppSelectionBarButton } from "@components";
import React from "react";

export default function ExecutionToolbarSelect({ selectedData, setSelectedRows }){
    const { handleStopMultipleExecutions } = useBatchMultiple(selectedData, setSelectedRows)

    return <AppSelectionBar count={selectedData?.length || 0} onClear={() => setSelectedRows([])}>
        <AppSelectionBarButton icon="circle-stop" label="Stop" title="Stop multiple executions" onClick={handleStopMultipleExecutions}/>
    </AppSelectionBar>
}